import { withRequiredForAutoInvoicing } from 'src/components/enterprise/features/Corporate/components/Form/withRequiredForAutoInvoicing/withRequiredForAutoInvoicing';
import { InvoiceContactFirstNameControl } from 'src/components/enterprise/features/Corporate/components/Form/InvoiceContactFirstNameControl/InvoiceContactFirstNameControl';
import { InvoiceContactLastNameControl } from 'src/components/enterprise/features/Corporate/components/Form/InvoiceContactLastNameControl/InvoiceContactLastNameControl';
import { InvoiceContactEmailControl } from 'src/components/enterprise/features/Corporate/components/Form/InvoiceContactEmail/InvoiceContactEmailControl';
import { InvoiceContactAddressControl } from 'src/components/enterprise/features/Corporate/components/Form/InvoiceContactAddressControl/InvoiceContactAddressControl';
import { InvoiceContactStateControl } from 'src/components/enterprise/features/Corporate/components/Form/InvoiceContactStateControl/InvoiceContactStateControl';
import { ZipCodeControl } from 'src/components/ZipCodeControl/ZipCodeControl';
import { InvoiceContactPhoneNumberControl } from 'src/components/enterprise/features/Corporate/components/Form/InvoiceContactPhoneNumber/InvoiceContactPhoneNumberControl';
import { InvoiceContactCityControl } from 'src/components/enterprise/features/Corporate/components/Form/InvoiceContactCity/InvoiceContactCityControl';

// Consolidated validation-wrapped components
export const InvoiceContactFirstName = withRequiredForAutoInvoicing(
  InvoiceContactFirstNameControl,
  'First Name is required'
);

export const InvoiceContactLastName = withRequiredForAutoInvoicing(
  InvoiceContactLastNameControl,
  'Last Name is required'
);

export const InvoiceContactEmail = withRequiredForAutoInvoicing(
  InvoiceContactEmailControl,
  'Email is required'
);

export const InvoiceContactPhoneNumber = withRequiredForAutoInvoicing(
  InvoiceContactPhoneNumberControl,
  'Phone Number is required'
);

export const InvoiceContactAddress = withRequiredForAutoInvoicing(
  InvoiceContactAddressControl,
  'Address is required'
);

export const InvoiceContactCity = withRequiredForAutoInvoicing(
  InvoiceContactCityControl,
  'City is required'
);

export const InvoiceContactState = withRequiredForAutoInvoicing(
  InvoiceContactStateControl,
  'State is required'
);

export const ZipCode = withRequiredForAutoInvoicing(
  ZipCodeControl,
  'Zip Code is required'
);
